"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const handlers_1 = require("./handlers/handlers");
class Patcher {
    static createObject(settings, defaultType, ...cargs) {
        let object;
        if (settings.type) {
            object = new settings.type(...cargs);
        }
        else {
            if (!defaultType) {
                throw new Error("No default type specified");
            }
            object = new defaultType(...cargs);
        }
        this.patchObject(object, settings);
        return object;
    }
    static patchObject(obj, settings) {
        const names = Object.keys(settings);
        for (let i = 0, n = names.length; i < n; i++) {
            const name = names[i];
            const value = settings[name];
            this.patchObjectProperty(obj, name, value);
        }
    }
    static patchObjectProperty(obj, name, value) {
        const handler = this.getHandler(obj, name);
        if (handler) {
            handler.handle(obj, value);
        }
        else {
            this.patchSimpleObjectProperty(obj, name, value);
        }
    }
    static patchSimpleObjectProperty(obj, name, value) {
        if (name !== "type") {
            obj[name] = value;
        }
    }
    static getHandler(obj, prop) {
        return handlers_1.handlers.find((handler) => handler.matches(obj, prop));
    }
}
exports.Patcher = Patcher;
//# sourceMappingURL=Patcher.js.map